import type { RouteRecordRaw } from "vue-router";
import { PostCourseRouteName } from "@/pages/courses/route/course";

export const postRoutes: RouteRecordRaw = {
  path: "/technician/post",
  component: () => import("@/layouts/post.vue"),
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: "",
      name: "post",
      component: () => import("@/pages/job/post.vue")
    },
    {
      path: "job",
      name: "post-job",
      component: () => import("@/pages/job/post-job.vue")
    },
    {
      path: "worker",
      name: "post-worker-profile",
      component: () => import("@/pages/worker/post-profile.vue")
    },
    {
      path: "salon",
      name: "post-salon",
      component: () => import("@/pages/salon-sale/post-salon.vue")
    },
    PostCourseRouteName()
  ]
};
